import { Modal, Text, Button, Group, Stack } from '@mantine/core';

interface NotValidatedAccountModalProps {
  setModalOpen: (value: boolean) => void;
  modalOpen: boolean;
}

export const NotValidatedAccountModal = (props: NotValidatedAccountModalProps) => {
  const { modalOpen, setModalOpen } = props;
  return (
    <Modal
      opened={modalOpen}
      onClose={() => setModalOpen(false)}
      title={
        <Text color="orange" weight={800} size={20}>
          Compte non valide
        </Text>
      }
      centered
      radius={24}
    >
      <Stack>
        <Text>Votre compte n'est pas encore activé ou a expiré.</Text>

        <Group position="right" mt="md">
          <Button onClick={() => setModalOpen(false)}>OK</Button>
        </Group>
      </Stack>
    </Modal>
  );
};
